/** @Note
 * this is not a react hook, you need to use this to get the correct path
 * of any next.js api
 */

/**
 *
 * @param relativeNextAPIUrl
 * @returns string
 * @description pass in /api/newrelic, output: /stencil/api/newrelic
 */
export default function getNextAPIURL(relativeNextAPIUrl: string) {
  if (!relativeNextAPIUrl.startsWith('/')) {
    throw new Error(`you need to start your relative Next API Url with '/'`)
  }

  return `${process.env.NEXT_PUBLIC_BASE_URL}${relativeNextAPIUrl}`
}
